<template>
    <div class="mt-2">
        <div id="personTable">
            <v-toolbar
                class="elevation-1 white--text"
                color="primary"
                height="50px"
            >
                <v-toolbar-title>
                    <v-icon size="20" class="white--text">fa-warehouse</v-icon>
                    Assets
                </v-toolbar-title>
                <v-divider
                    class="mx-2"
                    inset
                    vertical
                />
                <v-spacer />
                <EditAssetDialog />
                <AddAssetDialog :asset-id="assetId" />
            </v-toolbar>
            <v-data-table
                :search="assetTableSearch"
                :headers="assetTableHeaders"
                :items="personAssetListForTable"
                class="elevation-1"
                v-if="personAssetListForTable !== undefined"
            >
                <template
                    slot="item"
                    slot-scope="props"
                >
                    <tr>
                        <td class="text-xs-left">
                            {{props.item.ecsReferenceCode}}
                        </td>
                        <td class="text-xs-left">
                            {{props.item.serialNumber}}
                        </td>
                        <td class="text-xs-left">
                            {{ props.item.description }}
                        </td>
                        <td>
                            {{ props.item.assetType != null ? props.item.assetType.name : "" }}
                        </td>
                        <td
                            class="d-sm-table-cell text-xs-left"
                        >
                            {{ props.item.acquisitionDate | formatDate}}
                        </td>
                        <td
                            class="d-sm-table-cell text-xs-left"
                        >
                            {{ props.item.warrantyExpiryDate | formatDate}}
                        </td>
                        <td>
                            {{ props.item.cost }}
                        </td>
                        <td>
                            {{ props.item.currency != null ? props.item.currency.name : "" }}
                        </td>
                        <td>
                            {{ props.item.person != null ? props.item.person.name : "" }}
                        </td>
                        <td>
                            {{ props.item.comments }}
                        </td>
                        <td>
                            {{ props.item.assetStatus != null ? props.item.assetStatus.name : "" }}
                        </td>
                        <td
                            class="justify-center layout px-0"
                        >
                            <v-icon
                                @click="editItem(props.item)"
                                class="mr-2"
                                small
                                style="display: inline-flex;"
                            >
                                edit
                            </v-icon>
                              <v-icon
                                @click="deleteItem(props.item)"
                                small
                                style="display: inline-flex;"
                              >
                                delete
                              </v-icon>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from "vuex";
    import {DELETE_PERSON_ASSET, FETCH_PERSON_ASSET_LIST} from "@/store/person_asset/actions.js";
    import {LOAD_PERSON_ASSET_TO_EDIT, TOGGLE_EDIT_PERSON_ASSET_DIALOG} from "@/store/person_asset/mutations.js"
    import {FETCH_PERSONNEL,} from "@/store/person/actions.js";
    import EditTableFunctions from './../../ManagePersonnel/components/editTableFunctions';
    import AddAssetDialog from "./AddAssetDialog";
    import EditAssetDialog from "./EditAssetDialog";

    export default {

        components: {
            AddAssetDialog,
            EditAssetDialog,
        },

        mixins: [
            EditTableFunctions,
        ],

        data() {
            return {
                breadcrumbPath: [{text: process.env.VUE_APP_SYSTEM_NAME, to: "/"}, {text: 'Manage Assets', disabled: true,}],
                loading: true,
                personnelWithAssetTitle: [],
                selectedPersonnelId: '',
                assetId: '',
                idName: 'assetId',
                assetTableHeaders: [
                    {text: 'ECS Reference Code', value: 'ecsReferenceCode'},
                    {text: 'Serial Number', value: 'serialNumber'},
                    {
                        text: 'Description',
                        align: 'left',
                        value: 'description',
                    },
                    {text: 'Asset Type', value: 'assetTypeName'},
                    {text: 'Acquisition Date', value: 'acquisitionDate'},
                    {text: 'Warranty Expiry Date', value: 'warrantyExpiryDate'},
                    {text: 'Cost', value: 'cost'},
                    {text: 'Currency', value: 'currencyName'},
                    {text: 'Assigned To', value: 'personName'},
                    {text: 'Comments', value: 'comments'},
                    {text: 'Status', value: 'assetStatusName'},
                    {text: 'Actions', value: 'name', sortable: false}
                ],
                editedId: -1,
            };
        },

        computed: {
            ...mapGetters(
            [
                "personAssetListForTable",
                "assetTypeList",
                "getAssetTypeNameById",
                "getPersonNameById",
                "assetTableSearch",
                "assetStatusList",
                "getAssetStatusNameById",
                "currencyList",
                "getCurrencyNameById",
            ]
            )
        },

        mounted() {
            this.fetchAssets();

            if (
            this.$route.params !== undefined
            && this.$route.params.assetId !== undefined) {
                this.assetId = this.$route.params.assetId;
            }
        },


        methods: {
            fetchPersonnel() {
                this.$store.dispatch(FETCH_PERSONNEL);
            },
            fetchAssets() {
                this.$store.dispatch(FETCH_PERSON_ASSET_LIST);
            },

            // resetTable() {
            //     this.$store.commit(RESET_DEFAULT_NEW_ASSET_LIST);
            // },
            ...mapActions({
                fetchTableList: FETCH_PERSON_ASSET_LIST,
                deleteTableItem: DELETE_PERSON_ASSET
            }),

            ...mapMutations({
                toggleEditDialog: TOGGLE_EDIT_PERSON_ASSET_DIALOG,
                loadTableItemToEdit: LOAD_PERSON_ASSET_TO_EDIT,
            })
        },
    }
</script>

<style scoped>
    #assetTable {
        width: 100%;
        text-align: left;
        padding-left: 16px;
    }

    #assetTable th,
    #assetTable td {
        text-align: left;
    }
</style>
